import type { TemplateHelpExample, TemplateHelpVariable } from '@/components/actions/TemplateVariablesHelpDialog'

export const FACEBOOK_LEADS_TEMPLATE_HELP = {
  title: 'Variables plantillas Facebook leads',
  description:
    'Cada {{n}} del cuerpo de la plantilla Meta se asigna al vincular un Instant Form o una campaña. El orden lo marca la plantilla en Meta, no el backend.',
  orderNote:
    'El teléfono del lead no es una variable de plantilla: se extrae de field_data (phone_number, phone…) y se usa como destinatario del WhatsApp.',
  variablesTitle: 'Orígenes que puedes mapear',
  sourceLabel: 'Uso:',
  examplesTitle: 'Ejemplos de cuerpo de plantilla',
  variables: [
    {
      slot: '{{1}}…{{n}}',
      label: 'Huecos de la plantilla',
      source: 'En «Configurar plantilla» eliges qué campo rellena cada posición.',
      example: '{{1}} = nombre, {{2}} = ciudad del formulario',
    },
    {
      slot: 'Lead',
      label: 'Datos del lead',
      source: 'Nombre, email, teléfono normalizados desde field_data de Meta.',
      example: 'full_name, first_name, email, phone',
    },
    {
      slot: 'Formulario',
      label: 'Campos del Instant Form',
      source: 'Preguntas del formulario vinculado o unión de formularios detrás de los anuncios de la campaña.',
      example: 'city, presupuesto, preguntas personalizadas',
    },
    {
      slot: 'Contexto',
      label: 'Meta / campaña',
      source: 'Identificadores y nombres de formulario o campaña.',
      example: 'form_name, campaign_name, form_id, campaign_id',
    },
  ] satisfies TemplateHelpVariable[],
  examples: [
    {
      title: 'Saludo con nombre',
      text: 'Hola {{1}}, gracias por contactar con RK Iglesias. Te escribimos por WhatsApp para ayudarte.',
    },
    {
      title: 'Nombre + dato del formulario',
      text: 'Hola {{1}}, recibimos tu solicitud desde {{2}}. ¿Te va bien que hablemos por aquí?',
    },
  ] satisfies TemplateHelpExample[],
  note:
    'Backend: resolve_facebook_template_components aplica el variable_mapping guardado. Si un enlace no tiene mapeo, se usa compatibilidad legacy ({{1}} nombre, {{2}} email). Con mapeo incompleto no se envía la plantilla.',
} as const
